import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { FabricCategory } from '@app/models/item/fabric-categories/fabric-category';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class FabricCategoriesProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric-categories';

  public get(): Observable<ApiResponse<FabricCategory[]>> {
    return this.httpClient.get<ApiResponse<FabricCategory[]>>(`${this.baseUrl}/all`);
  }
}
